// emailTelo.js — rozdelí prijatú správu na to, s čím sa pracuje, a na to, čo je okolo nej.
//
// Mirko 8. 10. 2026: „Vo vlákne reklamácií kvôli prehľadnosti, ale aj inde, kde načítaš
// e-maily automaticky, rozdeľ hlavičku a pätičku, kde sú údaje viditeľne alebo farebne
// oddeľ, aby text — informácia, s ktorou pracujeme — bol v celom vlákne prehľadný."
//
// Dôvod: v jednom vlákne bola samotná správa („Dovoľujeme si Vám oznámiť, že evidujeme
// reklamáciu na časť diela…") utopená medzi podpisom, telefónmi, odkazmi na LinkedIn
// a dvanástimi riadkami právnej doložky.
//
// POZOR NA TVAR DÁT: lievík ukladá telo e-mailu ZLEPENÉ do jedného riadku (`\s+` → medzera),
// takže delenie podľa riadkov tu nemá čo nájsť — overené na skutočnej správe (4 142 znakov,
// nula zlomov). Preto sa hľadá podľa MIESTA V TEXTE, nie podľa riadkov.
//
// Nič sa neukladá a nič sa nemaže — delí sa len to, čo sa práve zobrazuje.

// Kde sa začína podpis (hľadá sa kdekoľvek v texte, nielen na začiatku riadku)
const PODPIS = /(s\s+pozdravom|s\s+(?:u|ú)ctou|so\s+(?:z|ž)elan(?:i|í)m|best\s+regards|kind\s+regards|with\s+regards|mit\s+freundlichen|\n--+\s*\n)/i;

// Kde sa začína právna doložka
const DOLOZKA = /(tento\s+(?:e-?mail|mail)\s+(?:m(?:o|ô)(?:z|ž)e|a\s+jeho|obsahuje)|t(?:a|á)to\s+spr(?:a|á)va\s+(?:m(?:o|ô)(?:z|ž)e|je\s+ur(?:c|č)en)|inform(?:a|á)cie\s+(?:obsiahnut|m(?:o|ô)(?:z|ž)u\s+podliehat)|d(?:o|ô)vern(?:e|é)\s+inform(?:a|á)ci|zamedzenie\s+pr(?:i|í)stupu|nenesie\s+zodpovednos|nie\s+ste\s+menovan(?:y|ý)m\s+adres(?:a|á)tom|this\s+e-?mail\s+(?:may|is)\b|confidentiality\s+notice|disclaimer)/i;

// Kontaktný chvost — telefóny, adresy, odkazy na siete
const KONTAKT = /((?:^|\s)(?:tel\.?|mobil|gsm|e-?mail)\s*[:.]?\s*\+?[0-9][0-9\s]{6,}|www\.[^\s]+|https?:\/\/[^\s]+|linkedin|facebook)/i;

export function rozdelSpravu(text) {
  const cely = String(text == null ? '' : text).replace(/\r/g, '');

  const mD = cely.match(DOLOZKA);
  const iDolozka = mD ? cely.indexOf(mD[0]) : -1;

  const predDolozkou = iDolozka >= 0 ? cely.slice(0, iDolozka) : cely;
  const mP = predDolozkou.match(PODPIS);
  let iPodpis = mP ? predDolozkou.indexOf(mP[0]) : -1;

  // Bez rozlúčenia: za podpis sa berie miesto, kde sa text zmení na samé kontakty a odkazy.
  if (iPodpis < 0) {
    const mK = predDolozkou.match(KONTAKT);
    if (mK) {
      const i = predDolozkou.indexOf(mK[0]);
      // berie sa len vtedy, keď je to naozaj chvost, nie telefón uprostred vety
      if (i > 0 && (predDolozkou.length - i) <= Math.max(400, predDolozkou.length * 0.45)) iPodpis = i;
    }
  }

  const orez = (s) => String(s || '').replace(/^[\s·,;—-]+|[\s·,;—-]+$/g, '');
  const telo = orez(predDolozkou.slice(0, iPodpis >= 0 ? iPodpis : predDolozkou.length));
  const podpis = iPodpis >= 0 ? orez(predDolozkou.slice(iPodpis)) : '';
  const dolozka = iDolozka >= 0 ? orez(cely.slice(iDolozka)) : '';

  // Poistka: keby delenie nechalo z dlhej správy len odrobinu, radšej sa neskryje nič.
  // Lepšie ukázať aj podpis, než stratiť vetu, kvôli ktorej človek do vlákna ide.
  if (telo.length < 120 && cely.length > 400) {
    return { telo: orez(cely), podpis: '', dolozka: '', maOkolie: false, uspora: 0 };
  }

  return {
    telo: telo || orez(cely),
    podpis,
    dolozka,
    maOkolie: !!(podpis || dolozka),
    uspora: podpis.length + dolozka.length,
  };
}

export default rozdelSpravu;
